// extracted by mini-css-extract-plugin
module.exports = {"noteBoxWrapper":"mobileNote_noteBoxWrapper__3GKnA"};